import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../components/common/SEO';
import { templatesData } from '../data/templatesData';
import TemplateDetailsHero from '../components/template-details/TemplateDetailsHero';
import TemplateFeaturesMatrix from '../components/template-details/TemplateFeaturesMatrix';
import TemplateDifferenceSection from '../components/template-details/TemplateDifferenceSection';
import TemplateBuyModal from '../components/template-details/TemplateBuyModal';

const TemplateDetailsPage = () => {
  const { themeId } = useParams();
  const [isBuyOpen, setIsBuyOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [themeId]);

  const cleanId = themeId ? themeId.toLowerCase().replace(/[^a-z0-9]/g, '') : '';

  const currentTemplate =
    templatesData.find(
      (t) =>
        t.slug === themeId ||
        t.slug.toLowerCase() === themeId?.toLowerCase() ||
        `theme${t.id}` === themeId ||
        `theme0${t.id}` === themeId ||
        String(t.id) === themeId ||
        t.slug.replace(/[^a-z0-9]/g, '') === cleanId
    ) || templatesData[0];

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: currentTemplate.name,
    description: `${currentTemplate.subtitle} - ${currentTemplate.tagline}`,
    offers: {
      '@type': 'Offer',
      price: currentTemplate.price.replace('$', ''),
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock'
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#f9f9f5] text-[#1C1917]">
      <SEO
        title={`${currentTemplate.name} Website Template`}
        description={`Explore the ${currentTemplate.name} website design template by SeaSalt Creative - ${currentTemplate.tagline}.`}
        schemaData={productSchema}
      />

      <TemplateDetailsHero
        template={currentTemplate}
        onOpenBuy={() => setIsBuyOpen(true)}
      />

      <TemplateFeaturesMatrix template={currentTemplate} />

      <TemplateDifferenceSection template={currentTemplate} />

      <TemplateBuyModal
        isOpen={isBuyOpen}
        onClose={() => setIsBuyOpen(false)}
        template={currentTemplate}
      />

    </div>
  );
};

export default TemplateDetailsPage;
